import { useQuery } from '@hooks/reactQuery';

import { getChangeMonitoringGroups } from '@api/manageNetworkElementConfigurations';

import { extractQueryParams } from '@utils/common';
import { mapDropdownOptions } from '@utils/formatter';

import { IIsActive } from '@interfaces/common/common';
import { IWithNetworkElementId } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CHANGE_MONITORING_GROUPS } from '@constants/queryKeys';

interface IUseQueryChangeMonitoringGroupsReturn {
	isLoadingChangeMonitoringGroups: boolean;
	changeMonitoringGroups: TSelectOptionType<string>[];
}

export const useQueryChangeMonitoringGroups = (
	params: IWithNetworkElementId & IIsActive,
): IUseQueryChangeMonitoringGroupsReturn => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CHANGE_MONITORING_GROUPS, params],
		queryFn: extractQueryParams(getChangeMonitoringGroups),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		enabled: [!!params.networkElementId],
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'groupNumber',
			labelKey: 'groupNumber',
			additionalMappings: {
				name: 'groupNumber',
			},
			preserveZeroValue: true,
		}),
		...refetchOptions,
	});

	return {
		isLoadingChangeMonitoringGroups: isInitialLoading,
		changeMonitoringGroups: data || [],
	};
};
